import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { NavController } from '@ionic/angular/standalone';

import { AuthService } from '@core/auth/services/auth.service';

export const onboardingGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const navController = inject(NavController);
  const token = await authService.getTokenPayload();

  if (token.patientId) {
    await navController.navigateForward(['home']);
    return false;
  }

  return true;
};
